import { render } from "./KingdomIn.vue?vue&type=template&id=1c38df9e"
import script from "./KingdomIn.vue?vue&type=script&lang=js"
export * from "./KingdomIn.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/pages/society/KingdomIn.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1c38df9e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1c38df9e', __exports__)) {
    api.reload('1c38df9e', __exports__)
  }
  
  module.hot.accept("./KingdomIn.vue?vue&type=template&id=1c38df9e", () => {
    api.rerender('1c38df9e', render)
  })

}


export default __exports__